module.exports = {"411571001":"城东街道","411571002":"珍珠路街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/411571.json
// module id = 1796
// module chunks = 0